import {
	EmailFieldRHF,
	EnhancedDropDownRHFWithLabel,
	PhoneNumberRHF,
	PostCodeRHF,
	RHookFormMaskedTextFieldWithLabel,
	RHookFormTextFieldWithLabel,
} from "@websential/cosmic-v20";
import { FC, useEffect, useState } from "react";

import { AuthService } from "../../../services";
import { Box } from "@mui/material";
import { CityService } from "../../../services/CityService";
import { CountryService } from "../../../services/common/CountryService";
import { useQuery } from "@tanstack/react-query";
import { sortDDLByLabel } from "../../../common/Common";

interface IAccountOrBankDetailsSetupFieldsPanel {
	formMethods: any;
	countryList: any;
	isLoadingData: (value: boolean) => void
	setDefaultSelectedCountry: (value: any) => void
}
export const AccountOrBankDetailsSetupFieldsPanel: FC<
	IAccountOrBankDetailsSetupFieldsPanel
> = ({ formMethods, countryList, isLoadingData, setDefaultSelectedCountry }) => {
	const [provinceOrStateDDL, setprovinceOrStateDDL] = useState(undefined);
	const [cityDDL, setCityDDL] = useState(undefined);
	const [countrytype, setCountrytype] = useState("Province");
	const [selectedCountryShortCode, setSelectedCountryShortCode] = useState("");
	const [selectedCountry, setSelectedCountry] = useState<any>("");
	const onCountryChangeHandler = async (e: any) => {
		setSelectedCountryShortCode(e.shortCode);
		setDefaultSelectedCountry(e.value);
		setSelectedCountry(e.value);
		let selected = e.value;
		setCountrytype(
			e.countryType === "province"
				? "Province"
				: e.countryType === "state"
					? "State"
					: e.countryType
		);
		formMethods.setValue("province", undefined);
		formMethods.setValue("state", undefined);
		try {
			isLoadingData(true);
			const responce = await AuthService.getProvinceOrStateDDL(
				selected,
				e.countryType
			);
			setprovinceOrStateDDL(responce);
		} catch {
		} finally {
			isLoadingData(false);
		}
	};

	const onProvinceChangeHandler = async (e: any) => {
		let selected = e.value;
		formMethods.setValue("city", undefined);
		try {
			isLoadingData(true);
			const responce = await AuthService.getCityDDL(selected);
			setCityDDL(responce);
		} catch {
		} finally {
			isLoadingData(false);
		}
	};

	useEffect(() => {
		if (countryList && Array.isArray(countryList)) {
			const canada = countryList.find(
				(item: any) => item.label === "Canada" || "canada"
			);
			if (canada) {
				setSelectedCountry(canada.value);
				setDefaultSelectedCountry(canada.value);
				setSelectedCountryShortCode(canada.shortCode ? canada.shortCode : "");
				(async () => {
					try {
						const response = await AuthService.getProvinceOrStateDDL(
							canada.value,
							"Province"
						);
						setprovinceOrStateDDL(response);
						//   provinceDDLItems(response);
					} catch (err) {
						console.error("error", err);
					}
				})();
			}
		}
	}, [
		countryList,
	]);
	return (
		<Box>
			<RHookFormTextFieldWithLabel
				label="Account Name"
				id="accTitle"
				testId={`account-title`}
			/>
			<RHookFormTextFieldWithLabel
				label="First Name"
				id="firstName"
				testId={`first-name`}
			/>
			<RHookFormTextFieldWithLabel
				label="Initial"
				id="initial"
				testId={`initial`}
			/>
			<RHookFormTextFieldWithLabel
				label="Last Name"
				id="lastName"
				testId={`last-name`}
			/>
			<RHookFormTextFieldWithLabel
				label="Address"
				id="addressLine1"
				testId={`accountant-addressLine1`}
			/>
			{/* <RHookFormTextFieldWithLabel
				label="City"
				id="city"
				testId={`city`}
			/> */}
			{/* <EnhancedDropDownRHFWithLabel
				selectName={"province"}
				label={"Province"}
				testId={`province-list`}
				items={provinceOrStateDDL ?? []}
				labelColumns={4}
				/> */}
			{countryList && selectedCountry && (
				<EnhancedDropDownRHFWithLabel
					selectName="country"
					label="Country"
					testId={`country-list`}
					items={countryList ?? []}
					selectedItem={selectedCountry}
					onSelectionChangeHandler={onCountryChangeHandler}
				/>
			)}
			{provinceOrStateDDL && (
				<EnhancedDropDownRHFWithLabel
					selectName={"province"}
					label={countrytype}
					testId={`province-list`}
					items={provinceOrStateDDL ?? []}
					onSelectionChangeHandler={onProvinceChangeHandler}
				/>
			)}
			{provinceOrStateDDL && cityDDL && (
				<EnhancedDropDownRHFWithLabel
					selectName={"city"}
					label={"City"}
					testId={`city-list`}
					items={cityDDL && sortDDLByLabel(cityDDL ?? [])}
				/>
			)}
			{/* <RHookFormTextFieldWithLabel
				label="Country"
				id="country"
				testId={`country`}
				readOnly={true}
			/> */}
			{/* <PostCodeRHF
				label="Post Code"
				id="postCode"
				testId={`accountant-post-code`}
			/> */}
			{selectedCountryShortCode === "CAN" ? (
				<PostCodeRHF
					label="Post Code"
					id="postCode"
					testId={`accountant-post-code`}
				/>
			) : selectedCountryShortCode === "USA" ? (
				<RHookFormMaskedTextFieldWithLabel
					label="Zip Code"
					id="zipCode"
					testId={`Zip-Code`}
					placeholder={"00000"}
					inputMaskPattern={"00000"}
				/>
			) : (
				<></>
			)}
			<PhoneNumberRHF
				id="phone"
				label="Phone"
				testId="phoneNumber"
			/>
			<PhoneNumberRHF
				id="fax"
				label="Fax"
				testId="faxNumber"
			/>
			<EmailFieldRHF
				label="Email"
				id="email"
				testId={`accounatnt-email`}
			/>

		</Box>
	);
};
